export default {"src":"/_next/static/media/icon-words-checker.f81cdda6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};